var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunctionIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 274.764,
    height: 275.43,
    viewBox: "0 0 274.764 275.43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#dee5f4;}.b,.c,.d,.e,.g,.h,.i,.m{fill:none;}.b,.c,.d{stroke:#0466c8;}.b{stroke-miterlimit:10;}.c,.g{stroke-width:5px;}.c{stroke-dasharray:10;}.d,.e{stroke-width:4px;}.e,.g,.h,.i{stroke:#95abd3;}.f{fill:#0466c8;}.g{stroke-dasharray:9;}.h,.i{stroke-width:3px;}.i{stroke-dasharray:5;}.j{opacity:0.213;}.k{fill:#cfe4fa;}.l{stroke:none;}.n{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 0,
    y: 25.848,
    width: 251.374,
    height: 109.64,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0466c8",
    floodOpacity: 0.353
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-585.101 -214)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-39.296 -20.166)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(676.656 270.996)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M802.665,455.918a49.637,49.637,0,0,1,49.568-47.043c1.509,0,3,.079,4.472.21a65.949,65.949,0,0,1,114-.054c1.244-.093,2.5-.157,3.764-.157a49.637,49.637,0,0,1,49.568,47.042",
    transform: "translate(-801.534 -376.278)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M810.778,452.921a49.637,49.637,0,0,1,49.568-47.043c1.509,0,3,.079,4.473.21a65.949,65.949,0,0,1,114-.054c1.244-.093,2.5-.157,3.764-.157a49.637,49.637,0,0,1,49.568,47.042",
    transform: "translate(-810.778 -373.277)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(638.266 275.014)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "n",
    transform: "matrix(1, 0, 0, 1, -13.87, -40.85)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M802.665,455.918a49.637,49.637,0,0,1,49.568-47.043c1.509,0,3,.079,4.472.21a65.949,65.949,0,0,1,114-.054c1.244-.093,2.5-.157,3.764-.157a49.637,49.637,0,0,1,49.568,47.042",
    transform: "translate(-787.67 -335.43)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M810.778,452.921a49.637,49.637,0,0,1,49.568-47.043c1.509,0,3,.079,4.473.21a65.949,65.949,0,0,1,114-.054c1.244-.093,2.5-.157,3.764-.157a49.637,49.637,0,0,1,49.568,47.042",
    transform: "translate(-810.778 -373.277)"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "c",
    x2: 182,
    transform: "translate(638.5 351.5)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M548.472,14517.341h62.1v-42.8",
    transform: "translate(46 -14090)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M604.227,14483.313l6.2-8.521,7.265,8.521",
    transform: "translate(46 -14090)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(775.472 384.536)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M610.568,14517.341h-62.1v-42.8",
    transform: "translate(-541.344 -14474.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M617.7,14483.313l-6.2-8.521-7.265,8.521",
    transform: "translate(-604.227 -14474.536)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(745.472 384.536)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M610.568,14557.978h-62.1v-83.441",
    transform: "translate(-541.344 -14474.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M617.7,14483.313l-6.2-8.521-7.265,8.521",
    transform: "translate(-604.227 -14474.536)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 20,
    cy: 20,
    r: 20,
    transform: "translate(668 442)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(589 214)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 20,
    cy: 20,
    r: 20
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 20,
    cy: 20,
    r: 17.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(801 214)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 25,
    cy: 25,
    r: 22.5
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 -3)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(689 280)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 19,
    cy: 19,
    r: 19
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 19,
    cy: 19,
    r: 17.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(687 278)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 21,
    cy: 20.5,
    rx: 21,
    ry: 20.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "m",
    cx: 21,
    cy: 20.5,
    rx: 19.5,
    ry: 19
  }))), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(63 18)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(689 280)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 13,
    cy: 13.5,
    rx: 13,
    ry: 13.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "m",
    cx: 13,
    cy: 13.5,
    rx: 11.5,
    ry: 12
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(687 278)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 15,
    cy: 15,
    r: 13.5
  }))), /*#__PURE__*/React.createElement("g", {
    className: "j",
    transform: "translate(-38 15)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "h",
    transform: "translate(689 280)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "l",
    cx: 13,
    cy: 13.5,
    rx: 13,
    ry: 13.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "m",
    cx: 13,
    cy: 13.5,
    rx: 11.5,
    ry: 12
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(687 278)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "l",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("circle", {
    className: "m",
    cx: 15,
    cy: 15,
    r: 13.5
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(626.472 384.536)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M548.472,14557.978h62.1v-83.441",
    transform: "translate(-548.472 -14474.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M604.227,14483.313l6.2-8.521,7.265,8.521",
    transform: "translate(-548.472 -14474.536)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(658.472 384.536)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M610.568,14579.43v-104.894",
    transform: "translate(-548.472 -14474.536)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M604.227,14483.313l6.2-8.521,7.265,8.521",
    transform: "translate(-548.472 -14474.536)"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "k",
    cx: 6,
    cy: 6,
    r: 6,
    transform: "translate(605 365)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "f",
    cx: 12,
    cy: 12,
    r: 12,
    transform: "translate(812 375)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunctionIllustration);
export default __webpack_public_path__ + "static/media/functionIllustration.99bbede7.svg";
export { ForwardRef as ReactComponent };